import React, { useState } from 'react';
import { IoCloseCircleOutline, IoLockClosedOutline, IoEyeOutline, IoEyeOffOutline } from 'react-icons/io5';

interface IProps {
    isOpen: boolean;
    onClose: () => void;
    onLoginSuccess: (documentUrl: string) => void;
}

export default function InvestorLoginModal({ isOpen, onClose, onLoginSuccess }: IProps) {
    const [senha, setSenha] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            // Fazer login
            const loginResponse = await fetch('https://app.chbrental.com.br/api/usuarios/investidores', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'CHB-API-KEY': 'rPa#N4k557pW',
                },
                body: JSON.stringify({ senha }),
            });

            if (!loginResponse.ok) {
                throw new Error('Senha incorreta');
            }

            // Buscar documento
            const documentResponse = await fetch('https://app.chbrental.com.br/api/site/investidores', {
                headers: {
                    'CHB-API-KEY': 'rPa#N4k557pW',
                },
            });
            const documentData = await documentResponse.json();

            if (documentData.documento) {
                onLoginSuccess(documentData.documento);
                onClose();
            } else {
                throw new Error('Documento não encontrado');
            }
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Erro ao fazer login');
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setSenha('');
        setError('');
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg max-w-md w-full p-6 relative">
                <button
                    onClick={handleClose}
                    className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
                >
                    <IoCloseCircleOutline size={24} />
                </button>

                <div className="mb-6">
                    <h2 className="text-2xl font-bold text-gray-900 mb-2">Área do Investidor</h2>
                    <p className="text-gray-600">Digite sua senha para acessar o documento</p>
                </div>

                <form onSubmit={handleLogin} className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Senha
                        </label>
                        <div className="relative">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                <IoLockClosedOutline className="h-5 w-5 text-gray-400" />
                            </div>
                            <input
                                type={showPassword ? 'text' : 'password'}
                                value={senha}
                                onChange={(e) => setSenha(e.target.value)}
                                className="block w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Digite sua senha"
                                required
                            />
                            <button
                                type="button"
                                onClick={() => setShowPassword(!showPassword)}
                                className="absolute inset-y-0 right-0 pr-3 flex items-center"
                            >
                                {showPassword ? (
                                    <IoEyeOffOutline className="h-5 w-5 text-gray-400" />
                                ) : (
                                    <IoEyeOutline className="h-5 w-5 text-gray-400" />
                                )}
                            </button>
                        </div>
                    </div>

                    {error && (
                        <div className="text-red-600 text-sm">{error}</div>
                    )}

                    <button
                        type="submit"
                        disabled={loading || !senha}
                        className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center justify-center"
                    >
                        {loading ? 'Entrando...' : 'Entrar'}
                    </button>
                </form>
            </div>
        </div>
    );
}
